import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// Custom wrapper component for better accessibility
const CustomProgressBar = ({ 
  now, 
  min = 0, 
  max, 
  ariaLabel,
  ariaHidden = false,
  dataTestId,
  progressBarStyle,
  style,
  className,
  bsClass,
  children,
  onClick
}) => {
  const progressPercentage = max > 0 ? Math.round((now / max) * 100) : 0
  
  return (
    <div 
      data-test-id={dataTestId}
      className={classnames(
        'progress',
        progressBarStyle?.base,
        style?.progressBar,
        className
      )}
      onClick={onClick}
    >
      <div 
        className={classnames(
          'progress-bar',
          progressBarStyle?.progressValueBase,
          style?.progressBarValue,
          bsClass
        )}
        style={{ width: `${progressPercentage}%` }}
        role="progressbar"
        aria-valuenow={now}
        aria-valuemin={min}
        aria-valuemax={max}
        aria-label={ariaLabel}
        aria-hidden={ariaHidden}
      >
        {children}
      </div>
    </div>
  )
}

CustomProgressBar.propTypes = {
  now: PropTypes.number.isRequired,
  min: PropTypes.number,
  max: PropTypes.number.isRequired,
  ariaLabel: PropTypes.string,
  ariaHidden: PropTypes.bool,
  dataTestId: PropTypes.string,
  progressBarStyle: PropTypes.object,
  style: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
  bsClass: PropTypes.string.isRequired,
  children: PropTypes.node,
  onClick: PropTypes.func
}

export default CustomProgressBar;